export const initialState = {
  type: 'size',
  show: false,
  path: '',
  displayed: 0
}
